import React from 'react';
import ReactQuill from 'react-quill';
import 'react-quill/dist/quill.snow.css';

interface EmailEditorProps {
  value?: string;
  onChange?: (content: string) => void;
}

const EmailEditor: React.FC<EmailEditorProps> = ({
  value,
  onChange = () => {},
}) => {
  const modules = {
    toolbar: {
      container: [
        [{ header: [1, 2, 3, 4, 5, 6, false] }],
        [{ font: [] }],
        [{ size: ['small', false, 'large', 'huge'] }],
        ['bold', 'italic', 'underline', 'strike'],
        [{ script: 'sub' }, { script: 'super' }],
        [{ color: [] }, { background: [] }],
        [{ align: ['', 'center', 'right', 'justify'] }],
        [{ direction: 'rtl' }],
        [{ list: 'ordered' }, { list: 'bullet' }],
        [{ indent: '-1' }, { indent: '+1' }],
        ['blockquote', 'code-block'],
        ['link', 'image', 'video'],
        ['clean'],
        ['source'],
      ],
    },

    clipboard: {
      matchVisual: false,
    },
    history: {
      delay: 1000,
      maxStack: 500,
      userOnly: true,
    },
  };

  return (
    <div className="editor-wrapper">
      <div className="editor-container">
        <ReactQuill
          theme="snow"
          value={value}
          onChange={onChange}
          modules={modules}
        />
      </div>
    </div>
  );
};

export default EmailEditor;
